module.exports = __webpack_public_path__ + "img/Owl_Pendant.1faf4540.png";